import { Flex, FlexProps } from "@chakra-ui/react";

import { ShelfLetter } from "ui/ShelfLetter/ShelfLetter";
import { HeaderS, TitleM } from "ui/Typography/Typography";

export type ShelfProps = {
  letter: string;
  number: string;
  variant?: "big" | "small";
} & FlexProps;

export function Shelf({ letter, number, variant = "big", ...rest }: ShelfProps) {
  return (
    <Flex alignItems="center" {...rest}>
      {variant === "big" ? (
        <HeaderS data-testid="shelf-number" mr="s100">
          {number}
        </HeaderS>
      ) : (
        <TitleM data-testid="shelf-number" mr="s50">
          {number}
        </TitleM>
      )}
      <ShelfLetter data-testid="shelf-letter" letter={letter} variant={variant} />
    </Flex>
  );
}
